






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component
export default class DetailConsentSection extends Vue {
  @Prop() consent!: any;

  get konfirmasiItems() {
    const c = this.consent;
    return [
      { label: "Telah diberikan informasi dan penjelasan tentang tindakan resusitasi jantung paru.", value: c.konfirmasi_info_resusitasi },
      { label: "Memahami manfaat RJP dan risiko kematian jika tidak dilakukan.", value: c.konfirmasi_manfaat_risiko },
      { label: "Bertanggung jawab penuh atas segala akibat.", value: c.konfirmasi_tanggung_jawab }
    ];
  }

  formatDate(date) {
    return getHumanDateTime(date);
  }
}
